<template>
  <component
    :is="getFormItemComponent"
    v-if="getFormItemComponent"
    :prop="getProp"
    :value="getValue"
    :data="data"
    :prefix="$page.prefix"
    :row="row"
    :label="getLabel"
    :item-binds="getFormItemBinds"
    v-bind="getComponentBinds"
    v-on="getOns"
  />
  <el-form-item v-else v-bind="getFormItemBinds">
    <component
      :is="getComponent"
      :prop="getProp"
      :value="getValue"
      :data="data"
      :prefix="$page.prefix"
      v-bind="getComponentBinds"
      v-on="getOns"
    />
  </el-form-item>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter'
function injectVmInFunction(vm, fns) {
  if (typeof fns === 'function') {
    return [(...rest) => fns(vm, ...rest)]
  } else if (typeof fns === 'object' && Array.isArray(fns)) {
    return fns.map(fn => (...rest) => fn(vm, ...rest))
  }
  return []
}
function injectVmInObject(vm, obj) {
  const fns = {}
  Object.keys(obj).forEach(key => {
    fns[key] = (...rest) => obj[key](vm, ...rest)
  })
  return fns
}

function getRules(rules) {
  if (Array.isArray(rules)) {
    return rules.map(rule => getRules.call(this, rule))
  } else {
    return { ...rules, required: typeof rules.required === 'function' ? rules.required(this.$page) : rules.required, validator: rules.validator && rules.validator.bind(this), message: rules.message && this.$t(rules.message) }
  }
}
export default {
  mixins: [emitter],
  inject: {
    $page: {
      default: () => ({})
    }
  },
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    getProp() {
      return this.option.prop || ''
    },
    getLabel() {
      return this.$te(this.option.label) ? this.$t(this.option.label) : this.option.label
    },
    getValue() {
      return this.data[this.getProp]
    },
    getComponent() {
      if (!this.option.formItem) {
        return null
      }
      if (typeof this.option.formItem === 'string') {
        return this.option.formItem
      }
      if (typeof this.option.formItem === 'object') {
        return this.option.formItem.component || null
      }
      return null
    },
    getFormItemComponent() {
      return this.option && this.option.formItemComponent
    },
    getFormItemBinds() {
      const binds = {}
      Object.keys(this.option).forEach(key => {
        if (!['formItem', 'col', 'label', 'formItemComponent'].includes(key)) {
          binds[key] = this.option[key]
        }
      })
      binds.label = this.getLabel
      binds.placeholder = this.$te(binds.placeholder) ? this.$t(binds.placeholder) : binds.placeholder
      binds.prop = typeof binds.prop === 'string' ? binds.prop : binds.prop[0] || ''
      binds.rules = getRules.call(this, binds.rules || [])
      return binds
    },
    getComponentBinds() {
      const binds = {}
      if (this.option.formItem && typeof this.option.formItem === 'object') {
        Object.keys(this.option.formItem).forEach(key => {
          if (!['component', 'data', 'formItemComponent', 'label', 'placeholder'].includes(key)) {
            binds[key] = this.option.formItem[key]
          }
        })
        if (binds.disabled !== undefined && typeof binds.disabled === 'function') {
          binds.disabled = binds.disabled(this)
        }
        binds.placeholder = this.$te(this.option.formItem.placeholder) ? this.$t(this.option.formItem.placeholder) : this.option.formItem.placeholder
      }
      return binds
    },
    getOns() {
      const changeEvent = {
        input: (...value) => {
          if (this.getProp && !Array.isArray(this.getProp)) {
            this.data[this.getProp] = value[0]
          }
          const key = this.option.mapKey || this.getProp
          if (key && !Array.isArray(key)) {
            // 触发change事件
            this.$emit('change', {
              prop: key,
              value: value[0],
              params: value
            })
          }
        }
      }
      if (this.option && typeof this.option === 'object' && this.option.on && typeof this.option.on === 'object') {
        const onInput = this.option.on.input
        if (onInput) {
          return {
            ...injectVmInObject(this, this.option.on),
            input: [...injectVmInFunction(this, onInput), changeEvent.input]
          }
        } else {
          return {
            ...injectVmInObject(this, this.option.on),
            ...changeEvent
          }
        }
      }
      return changeEvent
    }
  },
  methods: {
    setItem(prop, value) {
      if (!prop || !value) return
      this.dispatch('ZlFormPage', 'page.setitem', [prop, value])
    }
  }
}
</script>
